// extracted by mini-css-extract-plugin
module.exports = {"filter":"TongHopDiemDanhModal_filter__3hSlt","left":"TongHopDiemDanhModal_left__2-p8H","item":"TongHopDiemDanhModal_item__1LRfC"};